import LanguageControllerContainer from './LanguageControllerContainer'
import { withRouter } from 'react-router'

import { connect } from 'react-redux'
import ReduxActions from 'redux/actions'

const mapDispatchToProps = dispatch => {
  return {
    setLanguage: language => dispatch(ReduxActions.setLanguage(language))
  }
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(LanguageControllerContainer)
)



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageControllerContainer/index.js